import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DataManagementService} from '../services/data-management.service';
import {ToastrService} from 'ngx-toastr';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {AccessService} from '../services/access.service';
import {EpasUtilService} from '../services/epas-util.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Constants} from '../constants';
import {AppSettings} from '../../app-settings';
import { AuthenticationService } from '../services/authentication.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
    @ViewChild('universitiesModal') universitiesModal: TemplateRef<any>;
    @ViewChild('additionalInfoModal') additionalInfoModal: TemplateRef<any>;
    downloadVisaFile = AppSettings.DOWNLOAD_ISSUANCE_OF_STUDENT_VISA;
	downloadAdmission = AppSettings.DOWNLOAD_LETTER_OF_ADMISSION;
	downloadDocument = AppSettings.JAVA_API + AppSettings.DOWNLOAD_FACTSHEET_DOCUMENT;

    downloadNocDocument = AppSettings.DOWNLOAD_NOC_DOCUMENT;

    public modalReference: NgbModalRef;
    student;
    universities = [];
    registrationStatus;
    continentList;
    continentWiseUniversities = [];
    finalAllottedUniversity;
    practiceRoundAllottedUniversity;
    programmes = [];
    currentTermDetails;
    termDetails;
    pocUniversity;
    incomingStudentDetails;
    incomingTermDetails;
    objectKeys = Object.keys;
    errorMessage;
    activeRoundLink: string;
    activeRound: string;
    route: string;
    timer;
    isDataFetched;
    outgoingTerm;
    outgoingTermId = '0';
    incomingStudentId;
    pocId;
    selectUndefinedOptionValue = '0';
    oneUniversity;
    constants = Constants;

    token: any = undefined;

    constructor(
        private dmService: DataManagementService,
        private modal: NgbModal,
        private toastr: ToastrService,
        private accessService: AccessService,
        private utilService: EpasUtilService,
        private router: Router,
        private authService: AuthenticationService,
    ) {
        this.router.events.subscribe(event => {
            this.route = this.router.url;
        });
    }


    getOutgoingStudentInfo(): void {
        const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
        const termId = JSON.parse(localStorage.getItem('epas_user')).term.outgoing_term_id;
        this.dmService.javaGetDataCallByParameter(Constants.STUDENT_HOME, studentId + '/' + termId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.isDataFetched = true;
                        this.universities = response.data.university_details;
                        this.student = response.data.student_details;
                        this.finalAllottedUniversity = response.data.final_allotted_university;
                        this.practiceRoundAllottedUniversity = response.data.practice_round_allotted_university;
                        this.registrationStatus = response.data.registration_status;
                        if (this.universities.length === 0) {
                            this.errorMessage = 'There are no universities available';
                        }
                    } else if (response.status === 'fail') {
                        this.errorMessage = response.message;
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    toggleFavorite(university) {
        university.is_favourite = !university.is_favourite;
        const favData = {
            'outgoing_student_id': JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id,
            'university_id': university.university_id,
            'is_favourite': university.is_favourite
        };
        this.dmService.toggleUniversity(favData).subscribe(data => {
                if (data.status === 'success' && university.is_favourite === true) {
                    this.toastr.success('Successfully marked ' + university.university_name + ' as favourite.', 'Success');
                }
                if (data.status === 'success' && university.is_favourite === false) {
                    this.toastr.success('Successfully unmarked ' + university.university_name + ' from favourites.', 'Success');
                }
                if (data.status === 'fail') {
                    this.toastr.warning('Failed to mark/unmark' + university.university_name + ' as Favorite');
                }
                this.getOutgoingStudentInfo();
            },
            error => {
                this.toastr.error('Something is not right. Please refresh and reach out to contact team if the issue persists');
            });
    }

    getOIAInfo(): void {
        this.continentList = {};
        this.dmService.getOne(Constants.OIA_HOME, this.outgoingTermId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        }
                        if (!response.data.hasOwnProperty('universities')) {
                            this.errorMessage = 'There is no data available.';
                        } else {
                            this.universities = response.data.universities;
                            this.programmes = response.data.programmes;
                            for (let i = 0; i < this.universities.length; i++) {
                                const obj = this.universities[i];
                                if (!this.continentList.hasOwnProperty(obj.continent_name)) {
                                    this.continentList[obj.continent_name] = 0;
                                }
                                this.continentList[obj.continent_name]++;
                            }
                            if (this.universities.length === 0 || this.programmes.length === 0) {
                                this.errorMessage = 'There is no data available.';
                            }
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getAllTerms() {
        this.dmService.getAll(Constants.TERM_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.outgoingTerm = response.data.outgoing_terms;
                        if (this.outgoingTerm.length > 0) {
                            this.outgoingTermId = this.outgoingTerm[0].outgoing_term_id;
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getPOCInfo(): void {
        this.dmService.javaGetDataCallByParameter(Constants.POC_HOME_DETAILS, this.pocId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.termDetails = response.data;
                        if (this.termDetails.length <= 0) {
                            this.errorMessage = 'There are no term details available';
                        } else {
                            this.pocUniversity = this.termDetails[0].university_name;
                        }
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message') && response.message !== null) {
                            this.errorMessage = response.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getIncomingStudentInfo(): void {
        this.dmService.javaGetDataCallByParameter(Constants.INCOMING_STUDENT_HOME_DETAILS, this.incomingStudentId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.incomingStudentDetails = response.data.incoming_student_details;
                        this.incomingTermDetails = response.data.incoming_term;
                        if (this.incomingStudentDetails.length <= 0) {
                            this.errorMessage = 'There is no data available for nominations';
                        } else {
                            this.incomingTermDetails.nomination_start_date = this.getDateTime(this.incomingTermDetails.nomination_start_date);
                            this.incomingTermDetails.nomination_end_date = this.getDateTime(this.incomingTermDetails.nomination_end_date);
                        }
                        if (this.incomingTermDetails.length <= 0) {
                            this.errorMessage = 'There are no term details available';
                        }
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message') && response.message !== null) {
                            this.errorMessage = response.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getDate(date): string {
        if (date === undefined || date === null || date === '' || date === 'undefined') {
            return '';
        }
        return moment(date).format('Do MMM YYYY');
    }

    getDateTime(date): string {
        if (date === undefined || date === null || date === '' || date === 'undefined') {
            return '';
        }
        return moment(date).format('Do MMM YYYY HH:mm');
    }

    openUniversitiesModal(continent_name): void {
        this.continentWiseUniversities = [];
        for (let i = 0; i < this.universities.length; i++) {
            const obj = this.universities[i];
            if (obj.continent_name === continent_name) {
                this.continentWiseUniversities.push(obj);
            }
        }
        this.modalReference = this.modal.open(this.universitiesModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    openAdditionalInfoModal(university) {
        this.oneUniversity = university;
        this.modalReference = this.modal.open(this.additionalInfoModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    closeModal(): void {
        this.modalReference.close();
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessEC() {
        return this.accessService.canAccessEC();
    }

    canAccessOutgoingStudent() {
        return this.accessService.canAccessOutgoingStudent();
    }

    canAccessPOC() {
        return this.accessService.canAccessPOC();
    }

    canAccessIncomingStudent() {
        return this.accessService.canAccessIncomingStudent();
    }

    getNextRouterLink() {
        if (JSON.parse(localStorage.getItem('epas_user')) !== undefined &&
            JSON.parse(localStorage.getItem('epas_user')).hasOwnProperty('term') &&
            JSON.parse(localStorage.getItem('epas_user')).term !== null) {
            const studentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
            this.utilService.refreshTerm(studentId).subscribe(
                details => {
                    this.utilService.term = {rounds: details.data.rounds};
                    this.utilService.term.currentTime = details.data.current_time;
                    this.utilService.term.registration_start_time = details.data.term.registration_start_time;
                    this.utilService.term.registration_end_time = details.data.term.registration_end_time;
                    this.activeRoundLink = this.utilService.getNextActiveRoundRouterLink().split('#')[0];
                    this.activeRound = this.utilService.getNextActiveRoundRouterLink().split('#')[1];
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                });
        }
        if (this.route.indexOf('/home') === -1) {
            clearInterval(this.timer);
        }
    }

    isLoggedIn(): boolean {
        return this.authService.isLoggedIn();
    }

    ngOnInit() {
        if (this.isLoggedIn()) {
            this.token = this.authService.getToken();
          }
        this.route = this.router.url;
        if (this.canAccessOutgoingStudent()) {
            if (JSON.parse(localStorage.getItem('epas_user')) !== undefined &&
                JSON.parse(localStorage.getItem('epas_user')).term !== null &&
                JSON.parse(localStorage.getItem('epas_user')).term !== undefined) {
                this.getOutgoingStudentInfo();
                this.getNextRouterLink();
                this.timer = setInterval(() => {
                    this.getNextRouterLink();
                }, 30000);
            }
        } else if (this.canAccessOIA() || this.canAccessEC()) {
            this.getOIAInfo();
            this.getAllTerms();
        } else if (this.canAccessPOC()) {
            this.pocId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.poc_id;
            this.getPOCInfo();
        } else if (this.canAccessIncomingStudent()) {
            this.incomingStudentId = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.incoming_student_id;
            this.getIncomingStudentInfo();
        }
    }

    ngOnDestroy(): void {
        clearInterval(this.timer);
    }
}
